export default __webpack_public_path__ + "static/media/about-map.47827a1b.webp";